export const times = (n: number) => Array.from({ length: n }, (_, x) => x);